import { createLocaleMessages } from '@/utils/i18n';
import { basicColumnTitleEnUS } from './basicColumnTitle/en-US';
import { DefineLocalConfig } from './typings';

export default createLocaleMessages<DefineLocalConfig>({
  scanCode: {
    success: {
      title: 'Scanned successfully',
      des: `Tap "Allow" in WeChat to log in`,
    },
    reject: {
      title: 'Login has been canceled',
      des: 'Scan again to log in, or close the window',
    },
  },
  menuCollapse: {
    expand: 'Collapse Sidebar',
    collapse: 'Expand Sidebar',
  },
  help: {
    help: 'Help',
    kefu: 'Customer Service',
    feedback: 'Feedback',
  },
  agreePrivacy: 'I have read and agree to ',
  checkPrivacy: 'Please review and accept the agreement',
  autoRegisteredPhone:
    ', Unregistered phone numbers will be automatically registered.',
  and: 'and',
  generateSuccess: 'Generation successful! Please download.',
  home: {
    button: 'Start',
    knows: {
      des: 'Ask a question, and with one click, you can search the latest global literature, guidelines, and conferences. It can also help you generate clinical recommendations, research reviews, and conference reports.',
      tooltip: '',
    },
    project: {
      des: 'Batch upload literature and use the AI table tool to efficiently extract literature data and accurately filter documents. You can also specify multiple documents for real-time AI Q&A.',
      tooltip: '',
    },
    read: {
      des: 'Upload a single literature PDF and receive a PPT report in 30 seconds. We provide different interpretation schemes for various literature types, and AI real-time Q&A is \nsupported.',
      tooltip: '',
    },
    admin: {
      des: 'Management',
      tooltip: '',
    },
    records: {
      des: 'Data Analysis',
      tooltip: '',
    },
  },
  homeHUIZHI: {
    button: 'Start',
    knows: {
      des: 'Ask a question, and with one click, you can search the latest global literature, guidelines, and conferences. It can also help you generate clinical recommendations, research reviews, and conference reports.',
      tooltip: '',
    },
    project: {
      des: 'Batch upload literature and use the AI table tool to efficiently extract literature data and accurately filter documents. You can also specify multiple documents for real-time AI Q&A.',
      tooltip: '',
    },
    read: {
      des: 'Upload a single literature PDF and receive a PPT report in 30 seconds. We provide different interpretation schemes for various literature types, and AI real-time Q&A is \nsupported.',
      tooltip: '',
    },
    admin: {
      des: 'Management',
      tooltip: '',
    },
    records: {
      des: 'Data Analysis',
      tooltip: '',
    },
  },
  bindPhone: {
    info: 'Please bind the phone number and use it',
  },
  welcome: {
    enter: "Let's start",
    slogon: 'Medical Searching and Content Creation Platform in AI Era',
    oneStop:
      'Knowledge, Insights, Creating. Revolutionize the healthcare industry with AI.',
    start: "Let's start",
    mediflow: 'What is KnowS?',
    ai: {
      title: 'AI Search',
      des: 'Large model-based question and answer engine, support natural language, keyword search evidence to obtain summary answers',
    },
    paper: {
      title: 'SLR',
      des: 'The online AI literature data management tool supports the tabular batch extraction and generation of article summary, research value and other information',
    },
    read: {
      title: 'Chat with PDF',
      des: 'Chat with PDF\nGenerate PPT in 10 seconds',
    },
    policy: 'User Agreement',
    privacy: 'Privacy Policy',
    contact: 'Contact',
  },
  basicColumnTitle: basicColumnTitleEnUS,
  menu: {
    home: 'Home',
    knows: 'AI Search',
    manage: 'Systematic Review',
    read: 'Chat with Paper',
    admin: 'Admin',
    records: 'Dashboard',
    knowledge: 'Library',
    literature: 'Literature',
    open: 'Open',
    create: 'Unnamed',
    agent: 'Agent',
    pricing: 'Pricing',
    'domain-opportunity-map': 'Domain Opportunity Map',
    'case-deconstruction': 'High-Impact Case Deconstruction',
    'expert-strategy': 'Expert Strategy Probe',
    exploration: 'Mining of Research Directions',
  },
  menuHUIZHI: {
    home: 'Home',
    knows: 'AI Search',
    manage: 'SLR',
    read: 'Chat with Paper',
    admin: 'Management',
    knowledge: 'Knowledge Base',
    records: 'Data Analysis',
    open: 'Open',
    create: 'Unnamed',
  },
  chatPdfManage: {
    upload: {
      single: {
        title: 'Chat with PDF',
        desc: 'Chat with PDF\nGenerate PPT in 10 seconds',
        buttonText: 'Upload your PDF',
      },
      multiple: {
        title: 'Analyze with Multiple PDFs',
        desc: 'Comprehensive analysis of multiple documents.',
        buttonText: 'Coming soon',
      },
      loading: 'Uploading...',
      parsing: 'Parsing...',
      limit: 'The file size cannot exceed 50MB',
    },
    list: {
      title: 'My Files',
    },
    detail: {
      file_title: {
        abstract: 'Abstract',
        origin: 'Original document',
      },
      gen_ppt: {
        download: 'Download PPT',
        generating: 'PPT Generating',
        generate: 'Generate PPT',
      },
    },
  },
  manage: {
    unnamed: 'Unnamed',
    me: 'I',
    title: 'My Collections',
    newProjectImport: 'New Collection',
    updateSortLabel: 'By update time, from newest to oldest',
    createSortLabel: 'By create time, from newest to oldest',
    total: '{total} in total',
    des: 'Support questions, DOI, PMID, search query in Pubmed, upload PDF & Excel files and import documents',
  },
  created: 'Created on',
  updated: 'Updated on',
  ago: 'ago',
  phone: 'Phone',
  bind: 'Bind',
  weChat: 'WeChat',
  change: 'Change',
  logout: 'Log Out',
  confirm: 'Confirm',
  cancel: 'Cancel',
  delete: 'Delete',
  rename: 'Rename',
  recover: 'Recover',
  undo: 'Undo',
  clearFilter: 'Clear filter',
  filter: 'Filter',
  filter2: 'Filter by IF & Date',
  pin: {
    left: 'Pin to Left',
    right: 'Pin to Right',
  },
  hide: 'Hide',
  ascending: 'Ascending',
  descending: 'Descending',
  sortDateAsc: 'Oldest to Newest',
  sortDateDesc: 'Newest to Oldest',
  sortNumberAsc: 'Smallest to Biggest',
  sortNumberDesc: 'Biggest to Smallest',
  selectAll: 'Select All',
  introductionEvidence: {
    title: 'Import Evidence',
    limit: {
      row: 'The max size of one search is 10,000 items',
      info: 'The max size of one import is 10,000 items',
    },
    question: 'question',
    finding: 'searching',
    importAll: 'Import all',
    uploadText: 'Upload PDF file',
    identified: 'Identified evidence',
    ask: {
      title: 'Ask',
      placeholder:
        'Add evidence by asking questions, or import specified evidence...',
      enter: 'Search by AI',
      transformButton: 'Transfer to Pubmed search',
    },
    doi: {
      title: 'DOI',
      placeholder: 'Please enter the document DOI',
      enter: 'Add',
    },
    pmid: {
      title: 'PMID',
      placeholder: 'Please enter the document PMID',
      enter: 'Add',
    },
    pubmed: {
      title: 'Pubmed',
      placeholder: 'Please enter search query in Pubmed',
      enter: 'Add',
    },
    upload: {
      title: 'Upload PDF files',
    },
    excel: {
      title: 'Upload Excel',
      fileRuleTooltip: 'The first row of Excel must be the column names',
    },
    endnoteXml: {
      title: 'Upload EndNote File',
      placeholder: 'Please upload EndNote XML format file',
      enter: 'Import',
    },
  },
  excelUploadModal: {
    title:
      'Please select the "Literature Title Column" and "Literature Abstract Column" in the Excel file',
    description:
      'AI will extract information by default based on these two columns.',
    label: {
      title: 'Literature Title Column',
      abstract: 'Literature Abstract Column',
    },
    selectColumn: 'Select columns',
    warnRequireSelectTitle: 'Select the "Literature Title" column',
    warnSameSelect:
      '"Literature Title" and "Literature Abstract" cannot be the same',
  },
  export: 'Export',
  share: 'Share',
  shared: 'Shared',
  shareProject: 'Shared Project',
  shareBanTitle: 'When project sharing is turned on, data may be modified.',
  uploadLocalFiles: 'Upload PDF files',
  dropUpload: 'Drag and drop the file anywhere to upload it',
  projectName: 'Collection name',
  addComment: 'Add Notes',
  changeWeChatTitle: 'Change the binding wechat',
  weChatLoginTitle: 'Wechat scan code login',
  changeVerifyCode: 'Change the SMS authentication login',
  changeWeChatScanCode: 'Change wechat scan code login',
  or: 'or',
  google: {
    login: 'Google Login',
    loginText: 'Login with Google account',
    loginLoadingText: 'Processing Google login...',
    loginLoading: 'Please wait, verifying your identity',
    loginSuccess: 'Google login successful',
    loginFailed: 'Google login failed',
  },
  SMS: 'SMS Code Login',
  PASSWORD: 'Password Login',
  login: {
    text: 'Log in',
    email: {
      change: 'Log in with password',
    },
  },
  verifyMessageTitle: 'Verify SMS',
  getVerifyCode: 'code',
  verifyCode: 'Verify code',
  sms: {
    login: {
      phone: {
        place: 'enter your phone number',
        error: {
          info: 'Please enter the correct phone number',
        },
      },
      code: {
        place: 'Please enter the verification code',
      },
    },
  },
  autoRegis: 'New users will be automatically registered',
  seconds: 's',
  verifyCodeError: 'The verification code is incorrect',
  machineVerify: 'Machine verification',
  refresh: 'refresh',
  refresh1: 'Refresh',
  clearConversation: 'Clear conversation',
  pdfParsing: 'Parsing PDF, please hold on a moment...',
  enterGraphicVerify: 'Enter the graphic verification code above',
  email: {
    login: {
      account: 'Account',
      pwd: 'Password',
      passwordPlaceHolder: 'Please enter password',
      placeholder: 'Please enter your email address',
      placeholder2: 'Please enter your account',
      tips: 'New user registration',
    },
    register: {
      title: 'Register a new account',
      success: {
        msg: 'Email has been sent, please go to the email link to activate',
      },
      submit: 'Create an account',
      passwordPlaceholder: 'Password must be at least 6 characters',
      setPassword: 'Password',
      confirmPassword: 'Confirm password',
      tips: 'Already have an account',
      goLogin: 'Log in',
    },
    forget: {
      text: 'Forgot password',
      desc: 'Enter the email address you used to join and we will send you the password you need to reset.',
      success: {
        msg: 'Email has been sent, please go to the email link to reset the password',
      },
      submit: 'Verify and reset',
    },
    reset: {
      text: 'Reset password',
      password: 'New password',
      oldPassword: 'Old password',
      confirmPassword: 'Confirm new password',
    },
    message: {
      validEmail: 'Please enter the correct email address',
      validAccount:
        '6-20 characters; letters/numbers/@/./- allowed, at most one underscore; cannot start with . or -',
      confirmPassword: {
        empty: 'Please confirm the password',
        inconformity: 'Two passwords do not match',
      },
    },
  },
  machine: {
    verify: {
      error: 'The verification code is incorrect',
    },
  },
  question: {
    input: {
      placeholder: "I'd like to know more about the evidence",
    },
  },
  insert: {
    blank: {
      column: 'Insert blank column',
    },
  },
  display: {
    fields: 'Edit Column',
  },
  wantGetInfo: 'You may want to know',
  import: {
    loading: 'Importing',
    text: 'Import',
    record: 'Import History',
    done: 'Done',
    success: {
      info: 'Import successfully',
    },
  },
  blank: 'Blank',
  filters: 'Filters',
  fileUpload: {
    sizeLimit: 'File size must be less than {count}',
  },
  project: {
    deduplication: {
      button: 'Evidence Deduplication',
      title: 'Evidence Deduplication',
      loading: 'Calculating duplicate data...',
      keep: 'Keep',
      confirmTitle: 'Are you sure to deduplicate?',
      confirmDesc:
        'Data that is not retained will be deleted, and cannot be recovered after deletion.',
      hasSameCount: 'There are {count} similar data,',
      totalSameCount: 'Total {count} similar data,',
      judgeBy: 'Judgment basis:',
      keepCount: 'Keep {count} items,',
      removeCount: 'Remove {count} items',
      noData: 'No duplicate data',
    },
    process: {
      loadingText: 'Remaining {count} items',
      calculating: 'Calculating..',
      stop: 'Stop',
      halting: 'Stopping',
      delete: {
        desc: 'Do you want to interrupt and cancel all tasks currently running for this collection?',
        ok: 'Confirm Stop',
      },
      failed: '{count} failed',
      retry: 'Retry',
      failedText: 'AI run failed, click to retry',
    },
    popconfirm: {
      delete: {
        title: 'Are you sure to delete',
        desc: 'Are you sure to delete the selected item?',
        deleteColumn: 'Are you sure to delete this column?',
      },
    },
    prompFields: {
      pdf: 'PDF',
    },
    fields: {
      authors: basicColumnTitleEnUS.authors,
      journal: basicColumnTitleEnUS.journal,
      blankImpactFactorValue: 'Blank',
      impactFactor: 'IF: {value}',
    },
    blankQuestionTitle: 'Blank',
    blankQuestionContent: 'Blank',
    back: 'Back',
    analyzing: 'Analyzing...',
    relatedContent: 'Related Content',
    relatedTrials: 'Related Trials',
    references: 'References',
    citations: 'Citations',
    blankColumn: 'Blank Column',
    newBlankColumn: 'New Blank Column',
    newColumnButton: 'New {name} Column',
    newColumnInputPlaceholder: "I'd like to know more about…",
    batchCellModal: {
      button: 'Batch Edit',
      title: 'Batch Edit',
      placeholder: {
        selectColumn: 'Select column',
        text: 'Enter text',
        number: 'Enter number',
        date: 'Enter date',
      },
      operate: {
        clear: 'Clear',
        replace: 'Clear and replace',
        unshift: 'Add at the beginning of the text',
        push: 'Add at the end of the text',
      },
    },
    knows: {
      actionBar: {
        newButton: 'Dialogue with Selected Evidence',
        newLimitTip:
          'If the number of pieces of evidence exceeds {count}, the system will default to answering based on the first {count}.',
        research_proposal: 'Create Research Proposal with {title}', // 生成开题报告
        protocol: 'Develop Research Protocol with {title}', // 生成protocol
        review: 'Compose Literature Review with {title}', // 生成综述
      },
      drawer: {
        title: 'Chat with selected papers',
        close: 'Close',
        retry: 'Retry',
        answer: 'Answer: ',
        retryByUserCancel: 'User has stopped responding',
        stop: 'Stop',
        new: 'New conversation',
        networkError: 'Network error, please run again',
        feedbackTitle: 'Feedback',
        feedbackPlaceHolder: 'Feedback description',
        input: {
          placeholder: 'Enter your question',
          scopeLabel: 'Scope of Q&A: ',
          chooseScopeTitle: 'Select Q&A Scope',
          scopeContentLimitTip:
            'The selected scope is too long. The answer will be based on limited content',
          maxInputLengthLimitTip: 'Please optimize the length of your question',
          chooseAtLeastOneColumn:
            'Please choose at least one column for the conversation.',
        },
        evidences: {
          title: 'Selected Evidence Scope {count}',
          titleTour:
            'The system will answer based on the {count} pieces of evidence you have selected.',
          tourConfirm: 'Got it',
          abstract: 'Abstract',
          deleted: 'The evidence has been deleted. ',
          selectedFirst: 'Please select the evidence first.',
        },
        history: {
          title: 'History of Q&A',
          lengthLabel: 'Scope of Evidence:',
          lengthValue: '{count} pieces',
        },
      },
    },
    table: {
      details: 'Details',
      acquiring: 'Acquiring',
      configHelper: 'Edit',
      configHelperDone: 'Done',
      uploadFile: 'Upload PDF File',
      uploadingFile: 'Uploading',
      sortingInfo: {
        publishDateAsc: 'Oldest to Newest',
        publishDateDesc: 'Newest to Oldest',
      },
      filterInfo: {
        headerButton: '{count} Filter(s): ',
        dropdownTitle: 'Filters',
        itemSelected: '{count} value(s) selected',
      },
      filterMenu: {
        include: 'Include {total}',
        exclude: 'Not included {total}',
        reverse: 'Select Invert',
        all: 'Select All',
      },
      selected: '{count} evidence(s) selected',
      filterInputPlaceholder: 'Example：2020',
      filterUniqueValuesTotal: '{total}',
      deleteConfirm: {
        description: 'Are you sure to delete these {count} evidence(s) ?',
        successMessage: '{count} evidence(s) deleted',
      },
    },
    citationModal: {
      format: 'Format',
      cancel: 'Cancel',
      copy: 'Copy',
    },
  },
  records: {
    header: {
      total: '{total} in total',
    },
    advancedFilter: {
      dateRange: 'Date Range',
      filter: 'Filter',
      reset: 'Reset',
      today: 'Today',
      last3Days: 'Last 3 Days',
      last7Days: 'Last 7 Days',
      last14Days: 'Last 14 Days',
      last30Days: 'Last 30 Days',
      last90Days: 'Last 90 Days',
    },
  },
  expand: 'Expand',
  fold: 'Fold',
  upload: {
    document: 'Upload Document',
    success: 'Document uploaded successfully',
    dragText: 'Click or drag file to this area to upload',
    dragHint:
      'Supports various file formats, single file size should not exceed 100MB',
    sizeLimit: 'File size cannot exceed 100MB',
    noFile: 'Please select a file to upload first',
    tooLarge: {
      error: 'The file is too large and fails to be uploaded. Procedure',
      limit: {
        image: 'The maximum image limit is',
      },
    },
  },
  time: {
    unit: {
      now: 'now',
      minutes: 'minutes',
      hours: 'hours',
      days: 'days',
      weeks: 'weeks',
      months: 'months',
      years: 'years',
      month: 'month',
      year: 'year',
    },
  },
  ok: 'OK',
  prompt: {
    text: 'Describe your problem',
    example:
      'Example:Extract the words describing characteristics of the patients from the Text.',
    placeholder: 'Enter "@" to fill in column contents',
    clearConfirm: {
      // 确定清空既往值
      title: 'Confirm clearing the values',
      // 由于您的问题描述中对输出格式要求有变化，该列的结构会改变并清空既往值
      description:
        'Due to the change in the output format requirement mentioned in your problem description, the structure of that column will be modified and the previous values will be cleared.',
    },
    tooltip1:
      'When you only provide a question or instruction, we will default to asking about the "title" and "abstract" columns.',
    tooltip2:
      'You can also specify the column name you want to ask about by using "@" symbol.',
    example1: 'Example 1: Age of the patient',
    example2:
      'Example 2: Determine whether the included patients have NSCLC based on the @title@ abstract.',
  },
  notification: {
    copied: 'Copied successfully',
    noRowsSelected: 'Please select rows first',
    summarizeFirst: 'Please summarize first',
    guideDetailsPageIsUnderConstruction:
      'The guide details page is under construction',
    meetingDetailsPageIsUnderConstruction:
      'The meeting details page is under construction',
    isReceivingEvidences: 'Responding',
  },
  tooltip: {
    openInNewWindow: 'Open in new window',
    copyDOI: 'Copy DOI',
    copyPMID: 'Copy PMID',
    copyUrl: 'Copy URL',
    share: 'Share',
    shareCase: 'Share Case',
    shareCaseDesc: 'The task will be shared in the form of replay',
    copyLink: 'Copy Link',
    download: 'Download',
    generateCitation: 'Generate Citation',
  },
  copy: 'Copy',
  months: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },
  detail: {
    translation: {
      translate: 'Translation',
      successTip: 'Translation successful, click to download.',
      download: 'Click to Download',
      loading: 'Translating...',
    },
  },
  // knows module
  knows: {
    thematicReport: 'Thematic Report',
    thematicReportDrawer: {
      analyzeQuestion: 'Analyze Question',
      generateOutline: 'Generate Outline',
      generatePPT: 'Generate PPT',
      regeneratePPT: 'Regenerate PPT',
      history: 'History',
    },
    queryRecommend: {
      title: 'You may want to ask',
    },
    filters: {
      publishedSince: 'Published since',
      studyType: 'Study Type',
      Guidelines: 'Guidelines/Consensus',
      Meta: 'Meta Analysis/Systematic Review',
      RCT: 'RCT',
      ClinicalTrial: 'Clinical Trial (non-RCT)',
      Case: 'Case Series/Case Report',
      Literature: 'Literature Review (non-Systematic Review)',
      OtherTypes: 'Others',
      BasicResearch: 'Basic Research',
      ObservationalStudy: 'Observational Study',
      IF: 'IF',
      Q: 'Q{count}',
      subISTEC: 'ISTEC Sub Disciplines Division ',
      JCR: 'JCR Division',
      FullText: 'Open Access',
    },
    generatePptByIssueButton: 'Generate Academic PPT',
    downloadPptByIssueButton: 'Download Academic PPT',
    searchPlaceholder: 'Ask a Medical Question',
    searchSubmit: 'Search by AI',
    tabHotQuestions: 'Frequently asked questions',
    tabHistory: 'History',
    clearHistory: 'Clear',
    backTop: 'Top',
    summary: 'Summary',
    evidenceSearching: 'Evidence Searching: {count}',
    relevantEvidence: 'Relevant evidence: {count}',
    managePapers: 'Manage',
    aiHint: 'The content is generated by AI, please check it carefully.',
    summaryMode: {
      clinical: 'Clinical Advice',
      research: 'Academic Review',
      popular_science: 'Popular Science Education',
    },
    dataScope: {
      MEETING: 'Conference',
      PAPER: 'Literature(EN)',
      PAPER_CN: 'Literature(CN)',
      TOP_PAPER: 'High-Quality Literature',
      GUIDE: 'Guidelines',
      TRIAL: 'Trial',
      PACKAGE_INSERT: 'Package Insert',
    },
    evidenceList: {
      summaryError: 'AI Summary Failure',
      summaryProcessing: 'AI Summary In Progress...',
      sort_option: {
        by_time: 'From Recent to Old',
        by_if: 'From High to Low Impact Factor (IF)',
        by_relativity: 'From High to Low Relevance',
      },
    },
  },
  credits: {
    left: '{count} credits left',
    tips: 'One question for one row ≈ 1 credit,\n20~30 credits once per PDF',
    insufficient2: 'insufficient balance',
    insufficient:
      'The estimated consumption for this operation is {count} credits, which exceeds your current balance and is insufficient to run this operation.',
    largeAmountRemind:
      'The estimated consumption of credits for your current operation is {count} credits.',
    largeAmountRemind2:
      'Your operation is about to automatically run over {count} cells, which may incur certain costs. Please confirm again',
    usage: {
      tip: 'View credits usage',
      title: 'Credits usage',
      chat: 'Chat with papers',
      agent: 'Agent',
      received: 'Received {count} free credits',
      helpColumn: 'Data Extraction',
      noMore: 'No more',

      knowsAgentSystem: 'Agent',
      singleArticleInterpretation: 'Single Article Interpretation',
      fullTextTranslation: 'Full Text Translation',
      generatePPT: 'Generate PPT',
      singleQuestionAndAnswer: 'Single Question and Answer',
      pcSpecialReport: 'Special Report',
      mainQuestionAndAnswer: 'AI Quick Research',
      multipleSummaries: 'Multiple Summaries',
      multipleConversations: 'Multiple Conversations',
      unknown: 'Others',
    },
  },
  placeholder: {
    text: 'Please enter',
    select: 'Select the columns containing the target information',
  },
  priority: {
    HIGH_IF_VALUE: '影响因子优先',
    HIGH_RERANK_SCORE: '系统默认',
    HIGH_PUBLISH_DATE: '最新时间优先',
  },
  setting: {
    title: 'Setting',
    language: {
      title: 'Language',
      desc: 'Set your preferred language for interface and AI responses.',
      lang: {
        chinese: ' Chinese',
        english: 'English',
      },
    },
  },
  userInfo: {
    level: {
      label: 'Current Plan',
      upgrade: 'Upgrade',
      subscribe: 'Subs',
      renewal: 'Renewal',
      creditPayTip: 'Recharge available for Professional Edition only',

      free: 'Free',
      pro: 'Pro',
      bi_pro: 'Featured',
      // 个人版
      personal: 'Personal',
      professional: 'Professional',
      ultimate: 'Pro',
      customerservice: 'Enterprise',
    },

    payment: {
      amountPayable: '应付金额',
      productName: '商品名',
      startDate: '生效日期',
      // 年付价格：
      yearPayPrice: 'Annual price',
      endDate: '时效日期',
      scanToPay: '请扫码完成支付',
      freeGift: '免费赠送',
      payCodeText: 'Please add WeChat customer service to purchase rights.',
      payText: 'Purchase consultation',
      startNow: 'Start Now',
      subscribeNow: 'Subscribe Now',
      wechatPay: 'WeChat Pay',
      alipay: 'Alipay',
      wechatText: 'Please scan the code with WeChat to pay.',
      alipayText: 'Please scan the code with Alipay to pay.',
      actualPayment: 'Amount Payable',
      pleaseSelectPaymentMethod: 'Please select the following payment methods',
      discount: 'Discount',
      refresh: 'Refresh the page.',
      close: 'Close',
      paySuccess: 'Congratulations on opening the',
      qrCodeExpired: 'QR code expired.',
      qrCodeRefresh: 'Click to refresh.',
      workTime: 'Working hours',
      contactEmail: 'Contact email',
      invoiceAfterPay: 'Contact customer service after payment for invoice',
      contactCustomerService: 'Contact customer service for invoice',
      // 充值
      recharge: 'Recharge',
      // 积分充值
      creditsRecharge: 'Credits Recharge',
      creditTip:
        'Note: Credits cannot be exchanged for membership, cannot be transferred, and cannot be cashed out; Credits are valid for 1 year and do not support refunds or reverse conversion to RMB.',
    },
    permission: {
      upgrade: 'Unlock Premium Benefits',
      renewal: 'Renew KnowS Pro Edition.',
      subscribe: 'Member subscription service',
      monthPay: 'Monthly pay',
      yearPay: 'Annual pay',
      currentSubscribe: 'Current Subscription',
      invoice:
        'Support for issuing technical service invoices and conference training letters',
      subscribePlan: 'Subscription Plan',
      diamondBalance: 'Credit Balance',
      mostDiscount: 'Up to {discount}% discount',
      invoiceAfterPay: 'Contact customer service after payment for invoice',
      contactCustomerService: 'Contact customer service for invoice',
      businessManagement: 'Business Management:',
      businessManagementContent:
        'Employee account management, data security & data isolation',
      flagship: 'All rights to flagship version',
      moreUsage: 'More Usage',
      biggerDiscount: 'Bigger Discount',
      due: 'Due',
      baseScope: 'Covers guidelines, Chinese and English literature',
      groupAsk: 'AI Search',
      chat: 'Ask AI search questions',
      scope: 'Covers conferences',
      evidenceList: 'View evidence list',
      evidenceExport: 'Export evidence list',
      evidenceSummary:
        'AI-generated evidence summaries (for clinical, academic, and popular science purposes)',
      groupRead: 'AI Interpretation',
      evidenceDetail: 'Access detailed evidence',
      translate: 'Chinese-English translation',
      aiRead: 'One-click AI interpretation',
      genWord: 'Generate Word reports',
      genPpt: 'Generate PPT presentations',
      fullText: 'Full-text interactive deep reading',
      uploadPdf: 'Support for uploading PDF documents for interpretation',
      morePaperFilter: 'Systematic Literature Review (PC only)',
      multiPaperChat: 'Chat with Multi-evidence (PC only)',
      groupCommon: 'General',
      terminal: 'Sync usage across mobile and PC',
      share: 'Share evidence and summaries',
      response: 'Priority response during peak hours',
      customerService: 'Dedicated one-on-one customer support',
      trial: 'Early access to new AI features',
    },
  },
  document: {
    title: 'Document Name',
    type: 'Type',
    size: 'Size',
    modified: 'Modified Time',
    updated: 'Updated at',
    action: 'Actions',
    view: 'View',
    download: 'Download',
    upload: 'Upload Document',
    empty: 'Folder is empty, please upload documents',
    empty_search: 'No documents matching "{keyword}" found',
    search: 'Search documents',
    total: 'Total {total} items',
    delete: {
      button: 'Delete',
      confirm:
        'Are you sure you want to delete "{title}"? This action cannot be undone.',
      success: 'Document "{title}" has been deleted successfully',
    },
    download_failed: 'Download failed',
    preview_unsupported:
      'Online preview is not supported for this document type',
    create: 'Create Document',
    create_types: {
      text: 'Text Document',
      spreadsheet: 'Spreadsheet',
      presentation: 'Presentation',
    },
    sort: 'Sort by',
  },
  upgrade: {
    title: 'Upgrade',
    subtitle: 'Unlock all features',
    features: {
      pdf: 'Unlimited amount of PDF uploads',
      ai: 'Unlimited AI chat',
      extract: 'Unlimited data extraction',
      share: 'Evidence and summary sharing',
      response: 'Priority response during peak hours',
      customerService: 'One-on-one dedicated customer service',
      trial: 'Early access to more AI features',
    },
  },
  // Enterprise Knowledge Base Management
  kb: {
    title: 'Knowledge Base',
    tabs: {
      all: 'All',
      my: 'My Folders',
      shared: 'Shared',
    },
    folder: {
      empty: 'No folders yet, please create one',
      empty_search: 'No folders matching "{keyword}" found',
      loading: 'Loading...',
      create: 'Create Folder',
      edit: 'Edit Folder',
      name: 'Folder Name',
      rename: 'Rename',
      name_required: 'Please enter folder name',
      name_tooLong: 'Name cannot exceed 50 characters',
      name_placeholder: 'Enter folder name',
      description: 'Folder Description',
      description_tooLong: 'Description cannot exceed 200 characters',
      description_placeholder: 'Enter folder description (optional)',
      description_tip:
        'After creation, you can add various documents to the folder for knowledge management and sharing.',
      delete: {
        // 确定删除吗？
        title: 'Are you sure you want to delete?',
        confirm:
          'Are you sure you want to delete folder "{name}"? This action cannot be undone.',
        success: 'Folder "{name}" deleted successfully',
      },
      search: 'Search folders',
    },
    create: {
      folder: 'Create Folder',
      success: 'Folder created successfully',
      edit: {
        success: 'Folder updated successfully',
      },
    },
    document: {
      title: 'Document Name',
      type: 'Type',
      size: 'Size',
      modified: 'Modified Time',
      updated: 'Updated at',
      action: 'Actions',
      view: 'View',
      download: 'Download',
      upload: 'Upload Document',
      create: 'Create Document',
      create_types: {
        text: 'Text Document',
        spreadsheet: 'Spreadsheet',
        presentation: 'Presentation',
      },
      sort: 'Sort by',
      empty: 'Folder is empty, please upload documents',
      empty_search: 'No documents matching "{keyword}" found',
      search: 'Search documents',
      total: '{total} items in total',
      batch: {
        delete: 'Batch Delete',
      },
      delete: {
        button: 'Delete',
        confirm:
          'Are you sure you want to delete document "{title}"? This action cannot be undone.',
        success: 'Document "{title}" deleted successfully',
      },
      download_failed: 'Download failed',
      preview_unsupported: 'Preview for this document type is not supported',
    },
    upload: {
      dragText: 'Click or drag files to this area to upload',
      hint: 'Support single or batch file upload',
      submit: 'Start Upload',
      success: 'Upload successful',
      failed: 'Upload failed',
      empty: 'Please select files to upload',
      noNewFiles: 'No new files to upload',
      size_error: 'File size cannot exceed 100MB',
      type_error: 'Unsupported file type',
      supportFiles: 'Supported file types:',
      maxSize: 'Maximum file size:',
    },
  },
  common: {
    save: 'Save',
    create: 'Create',
    cancel: 'Cancel',
    refresh: 'Refresh',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    download: 'Download',
    upload: 'Upload',
    search: 'Search',
    back: 'Back',
    confirm: 'Confirm',
  },
  product: {
    all: 'All Products',
    diagnostic_agent: {
      title: 'MDT Agent',
    },
    quickqa: {
      title: 'AI Search',
      description: 'The All-in-One AI: Search, Analyze, Present.',
      quicksearch: {
        title: 'AI Semantic Search',
        description: 'Find, not just Search',
        placeholder: 'Describe your question clearly',
        summaryButton: 'Summary',
      },
      research: {
        title: 'AI Research Synthesis',
        description: 'Instant Research Synthesis',
        placeholder: 'Enter a research topic or field of study...',
        summaryButton: 'Build My Review',
      },
      clinical: {
        title: 'AI Clinical Synthesis',
        description: 'Decide with Evidence. Act with Confidence.',
        placeholder:
          'Enter key patient data (e.g., chief complaint, medical history, key findings)...',
        summaryButton: 'Get Guidance',
      },
      popular_science: {
        title: 'AI Concept Clarifier',
        description: 'Evidence-Based Answers, Patient-Friendly Language.',
        placeholder: 'What medical topic do you want to explain?',
        summaryButton: 'Explain It',
      },
      report_ppt: {
        title: 'AI Presentation Generator',
        description: 'From Topic to Presentation in Minutes.',
        placeholder: 'Enter your presentation topic or key points...',
        summaryButton: '',
      },
    },
    medagent: {
      title: 'Research',
      description: 'Not just an answer. A complete analysis.',
      tag: 'Agent',
      placeholder: 'Describe your research task or goal...',
      replay: 'Task History',
      replay2: 'Case Study',
      sameBtn: 'Do the Same',
      replayCases: 'Workflow Examples',

      // 去创作
      goCreate: 'Go to Create',
      // 重新回放
      replayAgain: 'Replay',
      // 新任务
      wantToCreate: 'New Task',
      // 回放已结束
      replayEnd: 'Task Completed',
      // 正在回放
      replaying: 'Replaying',
      // 您正在查看一个已完成的任务
      replayEndTip: 'You are viewing a completed task',
      // 回放任务
      replayTask: 'Replay Task',
      // 跳转到结果
      replayToResult: 'Jump to Result',
      // 继续执行
      continueTask: 'Continue Execution',
      // 正在执行
      executing: 'Executing',
      // 暂停并接管
      pauseAndTakeOver: 'Pause and Take Over',
      // 正在暂停
      pausing: 'Pausing',
      // 发送并
      sendAndContinue: 'Send and Continue',
      // 正在处理
      processing: 'Processing',
      // 已完成当前任务
      completedCurrentTask: 'Completed Current Task',
      // 您介入修改了搜索结果
      userIntervene: 'You intervened to modify the search results',
      // 任务中断
      taskInterrupted: 'Task Interrupted',
      // 暂停任务后可进行编辑
      pauseTaskEdit: 'Pause task editing',
      // 导出为HTML
      exportAsHtml: 'Export as HTML',
      // 导出为PDF
      exportAsPdf: 'Export as PDF',
      // 导出为Word
      exportAsWord: 'Export as Word',
      // 折叠证据
      foldEvidence: 'Fold Evidence',
      // 展开证据
      unfoldEvidence: 'Unfold Evidence',
      wajue: {
        title: 'Topic Recommender',
        description:
          'Out of ideas? Pinpoint cutting‑edge, high‑value research directions.',
        placeholder: 'Enter a research field or spark of inspiration…',
      },
      chuangxinfangan: {
        title: 'Feasibility Assessment',
        description:
          'Feasible or not? Compare research‑route costs and risks to guide your decision.',
        placeholder: 'Enter a specific hypothesis or question…',
      },
      daniu: {
        title: 'Expert Strategy Emulation',
        description:
          'Deconstruct and emulate the research frameworks of leading scientists.',
        placeholder:
          'Please enter your long-term focus or fleeting inspiration',
      },
      gaofen: {
        title: 'High-Impact Project Design',
        description:
          'Design and outline high-potential research projects for grant applications.',
        placeholder:
          'Please enter a clear scientific hypothesis or unresolved scientific problem',
      },
    },
    pdf: {
      title: 'More',
      description: 'Instant summaries. Instant slides.',
      chat: {
        title: 'Chat with PDF',
        description:
          'Ask questions, extract data, and get summaries from any uploaded document.',
      },
      translate: {
        title: 'Medical PDF Translator',
        description:
          'Translate entire research papers with a domain-specialized AI model for high accuracy.',
      },
      summary: {
        title: 'PDF to PPT',
        description:
          'Instantly convert any research paper or report into a presentation-ready slide deck.',
      },
    },
    pingjia: {
      title: 'Systematic Review',
      description: 'Months of screening in one hour.',
    },
    medppt: {
      title: 'Med PPT',
      description: '',
    },
    expertWorkbench: {
      title: 'Expert Workbench',
      consultation: 'Expert Consultation',
    },
    caseManage: {
      title: 'Clinical Case',
      description: '',
      expertConsultation: {
        title: 'Expert Consultation',
        selectExpert: 'Select Expert',
        consultQuestion: 'Consult Question',
        selectData: 'Attached Materials',
        originalCase: 'Original Case',
        caseSummary: 'Case Summary',
        diagnosticSuggestion: 'Diagnostic Suggestion',
        treatmentRecommendation: 'Treatment Recommendation',
        submit: 'Submit',
        cancel: 'Cancel',
        success: 'Consultation submitted successfully',
        error: {
          noExpert: 'Please select expert',
          noQuestion: 'Please enter consultation question',
          noData: 'Please select consultation data',
        },
      },
    },
  },
  documentTranslate: {
    title: 'AI Smart Document Translation',
    subtitle: 'Support PPT, Word, Excel formats',
    description:
      'Looking for a simple way to translate Office documents? Our AI smart translation tool can quickly translate your Office documents to the language you want while maintaining the original format and layout.',
    upload: {
      title: 'Upload Document',
      dragText: 'Drag files here, or',
      clickText: 'Click to Upload',
      supportedFormats: 'Supported formats: PPT, Word',
      maxSize: 'File size not exceeding 300MB',
      uploading: 'Uploading...',
      uploadSuccess: 'Upload Successful',
      uploadError: 'Upload Failed',
    },
    detail: {
      parsing: 'Parsing Document',
      parsingDesc: 'Analyzing document structure and layout information',
      translating: 'Translating Text Content',
      translatingDesc:
        'Intelligently translating the text content of the document',
      adjusting: 'Intelligent Adjusting Layout',
      adjustingDesc: 'Optimizing the layout of the translated document',
      generating: 'Generating Final File',
      generatingDesc: 'Generating the final downloadable translated document',
      translateFailed: 'Translation Failed',
      translateFailedDesc: 'There was a problem during the translation process',
      translateCompleted: 'Translation Completed',
      translateCompletedDesc: 'Your document has been successfully translated',
      translateProcessing: 'Translation in Progress',
      translateProcessingDesc: 'Please wait while we process your document...',
      failReasons: 'Failure Reasons',
      totalProgress: 'Total Progress',
    },
    features: {
      title: 'Why Choose Us?',
      subtitle:
        'We provide professional document translation services, allowing your presentations to easily cross language barriers',
      feature1: {
        title: 'AI Translation',
        description:
          'Advanced AI technology ensures accurate and fluent translations',
      },
      feature2: {
        title: 'Secure Transmission',
        description:
          'Encrypted file transmission ensures your privacy is protected',
      },
      feature3: {
        title: 'One-Click Download',
        description:
          'Download the translated document directly in the original format',
      },
      feature4: {
        title: 'Online Preview',
        description: 'Preview the translated result online before downloading',
      },
      feature5: {
        title: 'Multi-Language Support',
        description: 'Support multiple language translation for your documents',
      },
      feature6: {
        title: 'Quick Processing',
        description:
          'Average processing time of 2-5 minutes, large files can be completed quickly',
      },
    },
    tips: {
      title: 'Tips',
      content:
        'Images and text in charts within documents are not supported for translation, please handle manually after download.',
      security: 'Secure encrypted transmission',
      batch: 'Support batch processing',
      format: 'Support multiple formats',
      language: 'Support multiple language translation',
    },
    language: {
      setting: 'Translation Settings',
      selectLanguage: 'Select Translation Language',
      autoDetect: 'Auto Detect',
      source: 'Source Language',
      target: 'Target Language',
      english: 'English',
      chinese: 'Chinese',
      traditionalChinese: 'Traditional Chinese',
      simplifiedChinese: 'Simplified Chinese',
    },
    translate: {
      start: 'Start Translation',
      processing: 'Translating...',
      success: 'Translation completed!',
      error: 'Translation failed',
    },
    progress: {
      parsing: 'Parsing document structure...',
      translating: 'Translating text content...',
      adjusting: 'Intelligently adjusting layout...',
      generating: 'Generating final file...',
      slide: 'Slide',
      page: 'Page',
    },

    download: {
      title: 'Download Translated Document',
      other: 'Translate Other Documents',
    },
    status: {
      ready: 'Ready',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
    },
  },
  newHome: {
    slogan: 'KnowS Medicine，KnowS You',
    button: "LET'S START",
    whyknows: {
      title: 'Why KnowS？',
    },
    betterGpt: {
      title: 'Built for Medicine. Better than General AI.',
      better1:
        '1. Medically Fluent: Trained on millions of medical documents for unparalleled domain expertise.',
      better2:
        '2. Truly Evidence-Based: Real-time access to premier academic databases for trusted, current evidence.',
      better3:
        '3. Designed for Your Workflow: Generates ready-to-use outputs for your clinical and research workflows. ',
      bad1: '1. Lacks Medical Nuance: Prone to errors and hallucinations from misunderstood terminology.',
      bad2: '2. Limited, Unverified Sources: Relies on general web data, lacking clinical authority and rigour.',
      bad3: '3. Poor Clinical Utility: Generates generic answers requiring extensive prompting and correction.',
    },
    agent: {
      title: 'Medical Accuracy by Technology design.',
      section1: {
        title: 'Knowledge-Guided Reasoning.',
        des: 'Medical knowledge graph directs the AI, ensuring every conclusion is built on a foundation of facts',
      },
      section2: {
        title: 'Translation That Speaks Medicine.',
        des: 'Trained by medical experts, our model understands the nuance and context that others miss.',
      },
      section3: {
        title: 'Exclusive V&V (Verification & Validation) Engine',
        des: 'The V&V engine automatically fact-checks every result, so you can trust what you see.',
      },
    },
    footer: {
      contact: 'Contact Us',
      wechat: 'WeChat Official Account',
      wechat_enterprise: 'Customer Service (WeChat)',
      xhs: 'Red(e)note',
      privacy: 'Privacy Policy and Terms of Use Link:',
      work_time: 'Work Time',
      email: 'Email Contact',
    },
  },
});
